<script setup lang="ts">
import NotificationPanel from '@/components/notifications/NotificationPanel.vue';
import { useNotificationStore } from '@/stores/notification';
import { navIcons } from '@/utils/nav';
import { ref } from 'vue';

const notificationStore = useNotificationStore();

const isNotificationPanelOpen = ref(false);

function toggleNotificationPanel() {
    isNotificationPanelOpen.value = !isNotificationPanelOpen.value;
}

function include() {
    return [document.querySelector('.notification-bell') as HTMLElement];
}
</script>

<template>
    <div class="notification-bell">
        <div
            class="amount-of-unread-notifications"
            v-if="notificationStore.amountOfUnreadNotifications && notificationStore.amountOfUnreadNotifications > 0"
        >
            {{ notificationStore.amountOfUnreadNotifications }}
        </div>
        <v-icon class="notification-icon" :icon="navIcons.notifications" @click="toggleNotificationPanel" />
    </div>
    <NotificationPanel
        v-show="isNotificationPanelOpen"
        @close="isNotificationPanelOpen = false"
        v-click-outside="{ handler: () => (isNotificationPanelOpen = false), include }"
    />
</template>

<style scoped>
.notification-icon:hover {
    animation: tiltShaking 0.5s infinite alternate;
}

.notification-bell {
    position: fixed;
    z-index: 10000;
    top: 5px;
    right: 10px;
    padding: 10px;
    border-top-left-radius: 10px;
    transition: all 0.5s;

    i {
        cursor: pointer;
        color: var(--c-alt-lighter);
        font-size: 45px;

        &:hover {
            color: var(--c-alt-light);
        }
    }

    @media screen and (max-width: 960px) {
        top: 0px;
        i {
            font-size: 40px;
        }
    }
}

.amount-of-unread-notifications {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: var(--c-red);
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    z-index: 8;
}
</style>
